<template>
  <div>
    <!--    <button @click="getSelectedRows()">Get Selected Rows</button>-->
    <ag-grid-vue style="height: 550px"
                 class="ag-theme-balham"
                 :columnDefs="localcolumnDefs"
                 :rowData="localrowData"

                 :overlayLoadingTemplate="overlayLoadingTemplate"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue";
    import {eventBus} from '../../main'

    export default {
        name: 'DisplayContactInformation',
        props: ['columnDefs', 'rowData'],
        data() {
            return {
                // overlayLoadingTemplate: ' <img src="https://media.giphy.com/media/3oEjI6SIIHBdRxXI40/giphy.gif">',
                overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading, This may take up to 20seconds' +
                    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="38px" height="38px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">\n' +
                    '<path fill="none" stroke="#07abcc" stroke-width="8" stroke-dasharray="42.76482137044271 42.76482137044271" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px">\n' +
                    '  <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0;256.58892822265625"></animate>\n' +
                    '</path>\n' +
                    '<!-- [ldio] generated by https://loading.io/ --></svg>' +
                    '</span>',
                localcolumnDefs: null,
                localrowData: null,
                gridApi: null,
                columnApi: null,
                autoGroupColumnDef: null
            }
        },
        components: {
            AgGridVue,
            eventBus
        },
        methods: {
            // onGridReady(params) {
            //     this.gridApi = params.api;
            //     this.columnApi = params.columnApi;
            // },
            getSelectedRows() {
                const selectedNodes = this.gridApi.getSelectedNodes();
                console.log(' this.gridApi.getSelectedNodes()', this.gridApi.getSelectedNodes())
                const selectedData = selectedNodes.map(node => node.data);
                const selectedDataStringPresentation = selectedData.map(node => node.make + ' ' + node.model).join(', ');
            },
        },
        beforeMount() {
            this.localcolumnDefs = this.columnDefs;
            this.localrowData = this.rowData;
            // this.autoGroupColumnDef = {
            //     headerName: 'Name',
            //     field: 'name',
            //     cellRenderer: 'agGroupCellRenderer',
            //     cellRendererParams: {
            //         checkbox: true
            //     }
            // };

        },
        created() {
            eventBus.$on('rowDataAgGrid', dataPassed => {
                this.localrowData = dataPassed;
                // this.autoGroupColumnDef = {
                //     headerName: 'Name',
                //     field: 'name',
                //     cellRenderer: 'agGroupCellRenderer',
                //     cellRendererParams: {
                //         checkbox: true
                //     }
                // };
            });
        },
        beforeDestroy() {
            console.log('Imdestroyed')
        }

    }
</script>

